module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position"
  }, [_c('div', {
    staticClass: "position__button",
    class: {
      'position__button--within': _vm.positionWithinBounds
    },
    on: {
      "click": _vm.getCurrentPosition
    }
  }, [_c('div', {
    staticClass: "position__icon",
    class: {
      'position__icon--within': _vm.positionWithinBounds
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "position__text"
  }, [_vm._v(_vm._s(_vm.$t('myPosition')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06359b1e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Overview/partials/PositionButton.vue
// module id = 405
// module chunks = 1